export default {"src":"/_next/static/media/cart.50db165d.svg","height":30,"width":30};